class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

/* LaJodieen: part-number search using Turn14 MPN tags, with clean-tag fallback. */
if (!window.__lajodieenPartNumberSearchInstalledV2) {
  window.__lajodieenPartNumberSearchInstalledV2 = true;

  const toTagHandle = (value) =>
    value
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .replace(/-+/g, '-');

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const actionUrl = new URL(form.action || window.location.href, window.location.origin);
      if (!actionUrl.pathname.endsWith('/search')) return;

      const input = form.querySelector('input[name="q"]');
      const query = input?.value?.trim() || '';

      if (!query || query.length > 60 || !/\d/.test(query)) return;

      const mpnHandle = toTagHandle(`MPN:${query}`);
      if (!mpnHandle) return;

      const baseCollection =
        window.routes?.all_products_collection_url || '/collections/all';

      const target = new URL(
        `${baseCollection.replace(/\/$/, '')}/${encodeURIComponent(mpnHandle)}`,
        window.location.origin
      );
      target.searchParams.set('pn', query);
      target.searchParams.set('pn_stage', 'mpn');

      event.preventDefault();
      window.location.assign(target.toString());
    },
    true
  );
}

/* LaJodieen mobile search pass: clearer query guidance and larger touch targets. */
if (!window.__lajodieenMobileSearchPassV1) {
  window.__lajodieenMobileSearchPassV1 = true;

  const initLaJodieenMobileSearchPass = () => {
    if (!document.getElementById('lajodieen-mobile-search-style')) {
      const style = document.createElement('style');
      style.id = 'lajodieen-mobile-search-style';
      style.textContent = `
@media screen and (max-width: 749px) {
  form.lajodieen-search-form input[name="q"] {
    min-height: 4.9rem;
    font-size: 1.6rem;
  }

  form.lajodieen-search-form button[type="submit"],
  form.lajodieen-search-form button[type="reset"] {
    min-width: 4.8rem;
    min-height: 4.8rem;
  }

  .predictive-search__list-item .predictive-search__item {
    min-height: 6.4rem;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .predictive-search__item--link-with-thumbnail {
    grid-template-columns: 5.8rem 1fr;
    column-gap: 1.2rem;
  }
}`;
      document.head.appendChild(style);
    }

    const markSearchForms = () => {
      document.querySelectorAll('form').forEach((form) => {
        try {
          const actionUrl = new URL(form.action || window.location.href, window.location.origin);
          if (!actionUrl.pathname.endsWith('/search')) return;

          const input = form.querySelector('input[name="q"]');
          if (!input) return;

          form.classList.add('lajodieen-search-form');
          input.setAttribute('placeholder', 'Search part #, brand or product');
        } catch (error) {
          // Ignore malformed form actions.
        }
      });
    };

    markSearchForms();
    document.addEventListener('shopify:section:load', markSearchForms);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLaJodieenMobileSearchPass, { once: true });
  } else {
    initLaJodieenMobileSearchPass();
  }
}
